import axios from "axios";
import getUUID from "@Lib/uuid";
export * from "./url";

// 請勿放api不在到裡面打包時候會丟失
export * as Common from "./common";

export * as EffectiveAd from "./effectiveAd";

export * as buyCar from "./buyCar";

export * as inquiry from "./inquiry";

export * as Nav from "./nav";

export * as itemAd from "./itemAd";

export * as user from "./user";

export * as Special from "./special";

export * as freeTrial from "./freeTrial";

export * as article from "./article";

export * as Home from "./home";

export * as movie from './movie'

export * as ev from './ev'

export * as kindsum from './kindsum'

export * as Specification from './specification'

export * as appraiseTips from './appraiseTips'

axios.interceptors.request.use((config) => {
  config.params = config.params || {};
  config.params["device-id"] = getUUID();
  if (window.appToken) {
    config.params["token"] = window.appToken;
    config.params["sessionReset"] = "1";
  }
  if (config.url === "/user-getLoginedNav.html") {
    config.data = true;
    config.headers["Content-Type"] = "application/json";
  }
  return config;
});

export function get(url: string, params = {}) {
  return axios
    .get(url, {
      withCredentials: true,
      params,
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
    })
    .then((res: any) => {
      return res.data;
    });
}

export function post(url: string, params = {}) {
  const qs = require("qs");
  let data: string | { [key: string]: any };
  if (!!Object.values(params).find((item) => item instanceof File)) {
    data = new FormData();
    for (let key in params) {
      data.append(key, params[key]);
    }
  } else {
    data = qs.stringify(params);
  }
  return axios
    .post(url, data, {
      withCredentials: true,
    })
    .then((res: any) => {
      return res.data;
    });
}

export function postGeneric(url, data = {}) {
  return axios
    .post(url, JSON.stringify(data), {
      withCredentials: true,
    })
    .then((res) => res.data)
    .catch((error) => {
      console.log(error);
    });
}

